import { cn } from "@/shared/utils/utils";
import { Label } from "./label";
import { TextAreaProps } from "../extended/type";

const Textarea = ({
  labelName,
  className,
  placeholder,
  readOnly,
  value,
  required,
  rows,
  errors,
  ...props
}: TextAreaProps): React.ReactElement => {
  return (
    <>
      {labelName && (
        <Label className="mb-1.5">
          {labelName}
          {required && <span className="text-destructive -ml-1">*</span>}
        </Label>
      )}
      <div className="space-y-1">
        <textarea
          value={value}
          rows={rows ? rows : 5}
          required={required}
          placeholder={placeholder ? placeholder : labelName}
          readOnly={readOnly}
          data-slot="textarea"
          className={cn(
            "my-0 focus-visible:outline-0 focus:border-primary transition-all duration-200 text-sm w-full rounded-10 px-3.5 py-2.5 border border-border tracking-wide font-medium bg-white text-foreground resize-none placeholder:text-placeholder placeholder:tracking-wide",
            className,
          )}
          {...props}
        />
        {errors && (
          <p className="text-sm leading-tight text-red-500">{errors}</p>
        )}
      </div>
    </>
  );
};

export { Textarea };
